

let modalOpenBtn = document.querySelector('[data-info-icon]')
let modalContainer = document.querySelector('[data-info-modal]')
let modalCloseBtn = modalContainer.querySelector('.close-icon')
let opened = false

modalOpenBtn.addEventListener('click', (e) => {
  stretchModalOpen(e)
})

modalCloseBtn.addEventListener('click', (e) => {
  stretchModalClose(e)
})

modalOpenBtn.addEventListener('keyup', (e) => {
  if ((e.key == 'Enter' && opened == false) || (e.key == ' ' && opened == false)) {
    stretchModalOpen(e)
    opened = true
  }
})

modalCloseBtn.addEventListener('keyup', (e) => {
  if ((e.key == 'Enter' && opened == true) || (e.key == 'Escape' && opened == true)) {
    stretchModalClose(e)
    opened = false
  }
})

function stretchModalOpen(e) {
    modalContainer.classList.add('stretch__modal-wrapper--open')
}

function stretchModalClose(e) {
    modalContainer.classList.remove('stretch__modal-wrapper--open')
}
